import axios from "axios";

export const API_BASE =
  import.meta.env.VITE_API_BASE || "https://apicrdb.ssa.tg";

export function createApiClient(token?: string) {
  return axios.create({
    baseURL: `${API_BASE}/api/v1`,
    headers: {
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
